// components/layout/useModal.ts
import { useState } from 'react';

export const useModal = () => {
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    return {
        showPasswordModal,
        setShowPasswordModal,
        showProfileModal,
        setShowProfileModal,
        error,
        setError,
        success,
        setSuccess,
        isLoading,
        setIsLoading
    };
};